import React from "react";
import Signup from "../Components/Signup/Signup";
export const Signuppage = () => {
  return (
    <div>
      <Signup />
    </div>
  );
};
